import React from "react"
import { Form, Button, Input, Space, Table } from 'antd'
import { FormInstance } from "antd/lib/form"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from '../../tool/axios'
import { formItemLayout, tailLayout } from '../../js/globalParam'
import BreadCrumb from '../../component/BreadCrumb'
import Modal from "antd/lib/modal/Modal"

const { Column } = Table

interface State {
    data: object[],
    item: object | null,
    loading: boolean,
    pagination: {
        current: number,
        pageSize: number,
        total: number
    },
    fetchOtherParams: {
        type_name: string | null,
    },
    formParams: {
        item_type: string | null
    },
    type: string,
    addVisible: false
}

export default class ArticleTypeList extends React.Component {
    state: State = {
        data: [],
        type: 'add',
        item: {
            type_name: null,
            order_level: 0,
            remark: null
        },
        loading: false,
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0
        },
        fetchOtherParams: {
            type_name: null
        },
        formParams: {
            item_type: null
        },
        addVisible: false
    }

    formRef = React.createRef<FormInstance>()

    componentDidMount() {
        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
    }

    handleInputChange(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.type_name = e.target.value

        this.setState({ fetchOtherParams })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/manage_center/article_type/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            const { pagination } = this.state
            pagination.total = response.total
            pagination.pageSize = response.size
            pagination.current = response.current

            this.setState({
                pagination,
                data: response.records
            })
        })
    }

    resetForm() {
        const { fetchOtherParams, pagination } = this.state;

        this.setState({
            fetchOtherParams: {
                type_name: null
            }

        }, () => {
            fetchOtherParams.type_name = null
            this.fetch({ fetchOtherParams, pagination })
        })
    }

    selectState() {
        let { pagination, fetchOtherParams } = this.state;

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    reviewDetail(item: object | any) {
        this.setState({
            item,
            type: 'edit',
            addVisible: true
        })

        this.setState({ addVisible: true }, () => {
            for (let i in item) {
                this.formRef.current?.setFieldsValue({ [i]: item[i] })
            }
        })
    }

    confirmAdd() {
        let current: any = this.formRef.current;
        let obj: object | any = {}
        let url: string = ''

        for (let i in this.state.item) {
            obj[i] = current.getFieldValue(i)
        }

        if (obj.id) {
            url = '/manage_center/article_type/update'

        } else {
            url = '/manage_center/article_type/add'
        }

        baseAxiosComplete.post(url, obj).then((res) => {
            if (res.status == 0) {
                const { pagination, fetchOtherParams } = this.state
                this.fetch({ pagination, fetchOtherParams })

                this.setState({
                    addVisible: false
                })
            }
        })
    }

    closeModal() {
        this.setState({
            addVisible: false
        })
    }

    addItem() {
        let { item }: any = this.state;

        for (let i in item) {
            item[i] = null;
        }

        this.setState({
            addVisible: true,
            type: 'add',
            item
        })

        this.setState({ addVisible: true }, () => {
            for (let i in item) {
                this.formRef.current?.setFieldsValue({ [i]: item[i] })
            }
        })
    }

    render() {
        let { type_name } = this.state.fetchOtherParams

        return (<div className="common-page">
            {/* 管理中心 -> 文章管理 -> 文章分类 */}
            <BreadCrumb position={['管理中心', '文章分类']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="分类名称" value={type_name === null ? '' : type_name} onChange={this.handleInputChange.bind(this)} />

                    <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={this.selectState.bind(this)} >查询</Button>
                    <Button style={{ marginRight: 5, marginBottom: 12 }} onClick={this.resetForm.bind(this)} icon={<RedoOutlined />}>重置</Button>
                    <Button style={{ marginRight: 5, marginBottom: 12 }} type="primary" onClick={this.addItem.bind(this)}>添加</Button>
                </Space>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={this.state.pagination} onChange={this.handleTableChange.bind(this)}>
                    <Column title="分类名称" dataIndex="type_name" key="type_name" />
                    <Column title="备注" dataIndex="remark" key="remark" />
                    <Column title="排序" dataIndex="order_level" key="order_level" />
                    <Column title="创建时间" dataIndex="create_date" key="create_date" />

                    <Column
                        title="操作"
                        key="action"
                        render={(text, record: object) => (
                            <Space size="middle">
                                <Button type="primary" onClick={this.reviewDetail.bind(this, record)} >查看</Button>
                            </Space>
                        )}
                    />
                </Table>
            </div>

            <Modal title={this.state.type == 'edit' ? "编辑分类" : "新增分类"} visible={this.state.addVisible} footer={false} width="450px" onCancel={this.closeModal.bind(this)}>
                <Form name="validate_other" ref={this.formRef} {...formItemLayout} onFinish={this.confirmAdd.bind(this)}>
                    <Form.Item label="分类名称" name="type_name"
                        rules={[{ required: true, message: '必须填写分类名称' }, () => ({
                            validator(_, value) {
                                if (!/\s/.test(value)) {
                                    return Promise.resolve();
                                }

                                return Promise.reject(new Error('不能输入空格'));
                            },
                        })]}>
                        <Input maxLength={4} placeholder="请输入分类名称" />
                    </Form.Item>

                    <Form.Item label="排序" name="order_level"
                        rules={[{ required: true, message: '必须填写排序' }, () => ({
                            validator(_, value) {
                                if (/^[0-9]*$/.test(value) || !value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('请输入数字'));
                            },
                        })]}>
                        <Input placeholder="请输入排序" />
                    </Form.Item>

                    <Form.Item label="备注" name="remark">
                        <Input placeholder="请输入备注" />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit">提交</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>)
    }
}